import { render, staticRenderFns } from "./ArticoloDetails.vue?vue&type=template&id=10143b99&"
import script from "./ArticoloDetails.vue?vue&type=script&lang=js&"
export * from "./ArticoloDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArticoloDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports